import React from 'react';
import { Select } from 'antd';
import { WarehouseOption } from '../../../../hooks/useWarehouseOptions';
import { useTranslation } from 'react-i18next';
import InputFilterItem from '../../../delivery/components/InputFilterItem';
import { useFilterContainerClassName, useFilterLabelClassName, useFilterInputContainerClassName } from '../../../../utils/languageUtils';

export type CarrierFilterOptions = {
    carrierName: string;
    contactName: string;
    carrierType: number | null;  // 此 carrierType 为路线类型（干线/支线/干线+支线），与后端 carrierType 一致
    status: number | null;
};

export const DEFAULT_CARRIER_FILTER_OPTIONS: CarrierFilterOptions = {
    carrierName: '',
    contactName: '',
    carrierType: null,
    status: null
};

interface FilterAreaProps {
    warehousesOptions: WarehouseOption[];
    loading: boolean;
    filters: CarrierFilterOptions;
    setFilters: (filters: CarrierFilterOptions) => void;
}

const FilterArea: React.FC<FilterAreaProps> = ({ warehousesOptions, loading, filters, setFilters }) => {
    const { t } = useTranslation();
    const containerClassName = useFilterContainerClassName();
    const labelClassName = useFilterLabelClassName();
    const inputContainerClassName = useFilterInputContainerClassName();
    void warehousesOptions;

    return (
        <div className="mb-2 py-2">
            {/* 使用 Grid 布局确保列对齐 */}
            <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
                {/* 第一列 - 公司名称 */}
                <div className="min-w-0">
                    <InputFilterItem
                        label={t('central.carrier.pageDetails.companyName')}
                        value={filters.carrierName}
                        onChange={(e) => setFilters({ ...filters, carrierName: e.target.value })}
                        spanClassName="!mr-5 !w-[60px] !min-w-0 !flex-shrink-0"
                    />
                </div>
                {/* 第三列 - 统一宽度 w-[48px]（最长3字：联系人） */}
                <div className="min-w-0">
                    <InputFilterItem
                        label={t('central.carrier.pageDetails.contactName')}
                        value={filters.contactName}
                        onChange={(e) => setFilters({ ...filters, contactName: e.target.value })}
                        spanClassName="!mr-3 !w-[48px] !min-w-0 !flex-shrink-0"
                    />
                </div>
                {/* 第二行第一列 - 与第一列第一行同一标签宽度，保证 Select 左缘对齐 */}
                <div className="min-w-0">
                    <div className={containerClassName}>
                        <span className={`${labelClassName} !mr-2 !w-[84px] !min-w-0 !flex-shrink-0`}>{t('central.carrier.pageDetails.acceptedRouteType')}</span>
                        <div className={inputContainerClassName}>
                            <Select
                                allowClear
                                loading={loading}
                                placeholder={String(t('components.input.all'))}
                                className="w-full"
                                size="middle"
                                value={filters.carrierType ?? undefined}
                                onChange={(value) =>
                                    setFilters({ ...filters, carrierType: value ?? null })
                                }
                                options={[{
                                    value: 1,
                                    label: t('central.carrier.types.trunk')
                                },{
                                    value: 2,
                                    label: t('central.carrier.types.branch')
                                },{
                                    value: 3,
                                    label: t('central.carrier.types.trunkAndBranch')
                                }]
                                }
                            />
                        </div>
                    </div>
                </div>
                {/* 第二行 */}
                {/* 第一列 */}
                <div className="min-w-0">
                    <div className={containerClassName}>
                        <span className={`${labelClassName} !mr-5 !w-[60px] !min-w-0 !flex-shrink-0`}>{t('central.carrier.pageDetails.status')}</span>
                        <div className={inputContainerClassName}>
                            <Select
                                allowClear
                                loading={loading}
                                placeholder={String(t('components.input.all'))}
                                className="w-full"
                                size="middle"
                                value={filters.status ?? undefined}
                                onChange={(value) =>
                                    setFilters({ ...filters, status: value ?? null })
                                }
                                options={[{
                                    value: 1,
                                    label: t('enum.activeStatus.active')
                                },{
                                    value: 0,
                                    label: t('enum.activeStatus.suspended')
                                }]
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className="min-w-0"></div>
                <div className="min-w-0"></div>
            </div>
        </div>
    );
};

export default FilterArea; 